import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export const useTileStatusStore = create<{
  tileIsLoadingById: Record<string, boolean>
  setTileIsLoading: (id: string, isLoading: boolean) => void
}>()(
  devtools(
    immer((setState) => ({
      tileIsLoadingById: {},
      setTileIsLoading: (id: string, isLoading) =>
        setState(
          (state) => {
            state.tileIsLoadingById[id] = isLoading
          },
          false,
          `setTileIsLoading`,
        ),
    })),
    { name: 'TileStatusStore' },
  ),
)
